export var SiderCollapsedKey = Symbol('siderCollapsed');
export var SiderHookProviderKey = Symbol('siderHookProvider');